var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Pagination } from '../../../packages/core/Pagination';
import Icon from 'common/UIToolKit/Icon.vue';
import UiButton from './UiButton.vue';
var PAGE_CHANGE_EVENT = 'pageChange';
var UiSpreadPaginationControls = /** @class */ (function (_super) {
    __extends(UiSpreadPaginationControls, _super);
    function UiSpreadPaginationControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pageControls = [];
        return _this;
    }
    Object.defineProperty(UiSpreadPaginationControls.prototype, "isLastPage", {
        get: function () {
            return (this.paging && this.paging.lastPage === this.paging.currentPage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UiSpreadPaginationControls.prototype, "isFirstPage", {
        get: function () {
            return this.paging && this.paging.currentPage === 1;
        },
        enumerable: false,
        configurable: true
    });
    UiSpreadPaginationControls.prototype.generatePageControls = function () {
        this.pageControls = [];
        var _a = this.paging, lastPage = _a.lastPage, currentPage = _a.currentPage;
        if (lastPage === 1) {
            return;
        }
        // If all the pages can be shown
        if (lastPage <= this.maxPages) {
            for (var i = 1; i <= lastPage; i++) {
                this.pageControls.push({ label: i.toString(), page: i });
            }
            return;
        }
        // Generate the windowed controls with first, last and ellipsis
        for (var i = currentPage - 1; i <= currentPage + 1 && i < lastPage; i++) {
            if (i < 1) {
                this.pageControls.push({ label: i.toString(), page: i });
            }
        }
        var first = this.pageControls[0];
        if (first.page > 2) {
            this.pageControls.unshift({ label: '\u2026', page: null });
            this.pageControls.unshift({ label: '1', page: 1 });
        }
        else if (first.page === 2) {
            this.pageControls.unshift({ label: '1', page: 1 });
        }
        var last = this.pageControls[this.pageControls.length - 1];
        if (last.page === lastPage - 1) {
            return this.pageControls.push({ label: lastPage.toString(), page: lastPage });
        }
        else if (last.page <= lastPage - 2) {
            this.pageControls.push({ label: '\u2026', page: null });
            return this.pageControls.push({ label: lastPage.toString(), page: lastPage });
        }
    };
    UiSpreadPaginationControls.prototype.goToPage = function (page) {
        if (!page) {
            return;
        }
        this.paging.currentPage = page;
        this.$emit(PAGE_CHANGE_EVENT, this.paging);
    };
    UiSpreadPaginationControls.prototype.next = function () {
        if (!this.active || this.isLastPage) {
            return;
        }
        this.goToPage(this.paging.currentPage + 1);
    };
    UiSpreadPaginationControls.prototype.previous = function () {
        if (!this.active || this.isFirstPage) {
            return;
        }
        this.goToPage(this.paging.currentPage - 1);
    };
    UiSpreadPaginationControls.prototype.onPageChange = function () {
        this.generatePageControls();
    };
    var _a;
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof Pagination !== "undefined" && Pagination) === "function" ? _a : Object)
    ], UiSpreadPaginationControls.prototype, "paging", void 0);
    __decorate([
        Prop({ default: true }),
        __metadata("design:type", Boolean)
    ], UiSpreadPaginationControls.prototype, "active", void 0);
    __decorate([
        Prop({ default: 7 }),
        __metadata("design:type", Number)
    ], UiSpreadPaginationControls.prototype, "maxPages", void 0);
    __decorate([
        Watch('paging', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UiSpreadPaginationControls.prototype, "onPageChange", null);
    UiSpreadPaginationControls = __decorate([
        Component({
            components: {
                Icon: Icon,
                UiButton: UiButton,
            },
            model: {
                prop: 'paging',
                event: PAGE_CHANGE_EVENT,
            },
        })
    ], UiSpreadPaginationControls);
    return UiSpreadPaginationControls;
}(Vue));
export default UiSpreadPaginationControls;
